import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@/styles/global.css';

import { App } from '@/app/app';
import { runtimeConfig } from '@/config/runtime-config';
import { initAnalytics } from '@/lib/analytics';

const root = document.getElementById('root');
if (!root) throw new Error('#root missing');

// Fail at boot, visibly, if the environment did not mount a runtime config.
runtimeConfig();
initAnalytics();

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
